import { usePassportFormState, } from "./usePassportFormState.ts";
import { useEffect, } from "react";
import {
  EPassportFormState,
  PASSPORT_FOREIGN,
  PASSPORT_RF,
} from "../../../../../store/slices/passportFormSliceCreator.ts";
import { usePhoneFormState, } from "../../PhoneNumberForm/hooks";
import { useSMSFormState, } from "../../SMSForm/hooks";
import { RoutesMap, } from "../../../../../routes.tsx";
import { useNavigate, } from "react-router-dom";
import { PASSPORT_ERROR_MESSAGES, } from "../utils";
import { usePassportMutationReaction, } from "./usePassportMutationReaction.ts";
import { useReturnTo, } from "../../../../../utils";

export function usePassportFormStateReaction() {
  const navigate = useNavigate();
  const passportForm = usePassportFormState();
  const phoneForm = usePhoneFormState();
  const smsForm = useSMSFormState();
  const { withReturnTo, } = useReturnTo();

  const verifyPassport = usePassportMutationReaction();

  useEffect(() => {
    switch (passportForm.formState) {
      case EPassportFormState.validating: {
        if (passportForm.passportNumber.length === 0) {
          passportForm.setTextError(PASSPORT_ERROR_MESSAGES.passportIsEmpty,);
          passportForm.setFormState(EPassportFormState.initial,);
          return;
        }
        if ((passportForm.passportType === PASSPORT_RF) && passportForm.passportNumber.length < 10) {
          passportForm.setTextError(PASSPORT_ERROR_MESSAGES.passportIsTooShort,);
          passportForm.setFormState(EPassportFormState.initial,);
          return;
        }
        if ((passportForm.passportType === PASSPORT_FOREIGN) && passportForm.passportNumber.length < 6) {
          passportForm.setTextError(PASSPORT_ERROR_MESSAGES.passportIsTooShort,);
          passportForm.setFormState(EPassportFormState.initial,);
          return;
        }
        passportForm.setFormState(EPassportFormState.validated,);
        return;
      }
      case EPassportFormState.validated: {
        verifyPassport.mutate({ phone: phoneForm.getEscapedPhoneNumber(), code: smsForm.code, passport: passportForm.getEscapedPassportNumber(), },);
        passportForm.setFormState(EPassportFormState.submitting,);
        return;
      }
      case EPassportFormState.submitted: {
        navigate(withReturnTo(RoutesMap.login.pin,),);
        return;
      }
    }
  }, [passportForm.formState,],);
}
